import { Form } from 'antd';
import cookie from 'react-cookies';
// @ts-ignore
import Base64 from 'crypto-js/enc-base64';
// @ts-ignore
import { sendPostErrorMonitoring } from '@/appComps/ErrorMonitoringCommon/api';
import EcoCreditDescription from '@/components/EcoCreditDescription';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import SocialLoginLinks from '@/components/SocailLoginLinks';
import Button from '@/components/UI/Button';
import Input from '@/components/UI/Input';
import { EFAkIn, EFAkout } from '@/components/UI/svg/My';
import { ENGLISH_LANG, i18nMap, newVersionRegion, rpcMap } from '@/constants';
import { FORUM_APPID_MAP, LOGIN_MAP } from '@/constants/forum';
import seoconfig from '@/seoconfig/login';
import { authSignIn, checkHumanMachine, toLogin } from '@/service';
import { getHostApi, redirectTo404 } from '@/utils';
import { onLogin } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { getCountryRegion } from '@/utils/countryRegion';
import { usePageBackground } from '@/utils/hooks/usePageBackground';
import { getKaamelPlan } from '@/utils/kaamelTest';
import { isMembersFestival } from '@/utils/membersFestival';
import { useGlobal } from '@/utils/useGlobal';
import Utf8 from 'crypto-js/enc-utf8';
import Head from 'next/head';
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './login.module.scss';
import CountDown from '@/components/CountDown';
import useLoginCode from './useLoginCode';
import './login.scss';

const wordpress_site = process.env.NEXT_PUBLIC_WORDPRESS_SITE;
const HOMEBATTERY_REDIRECT = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;
const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;
const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;

const FORUM_HOST = process.env.NEXT_PUBLIC_FORUM_DOMAIN;
// previous routes which aren't allow
const prevUrlBalckList = ['/login', '/register', '/validate', '/forget'];

export default function Login({ redirect: redirectUrl, prevPath, otherQuery, lang, SEO }: any) {
    if (redirectUrl.split('redirect=')[1]) {
        redirectUrl = redirectUrl.split('redirect=')[1];
    }
    if (otherQuery?._source !== LOGIN_MAP.ECOFLOW_WEB_COMMUNITY && Object.keys(otherQuery)?.length > 0) {
        redirectUrl = `${redirectUrl}${redirectUrl.indexOf('?') > -1 ? '&' : '?'}${Object.keys(otherQuery)
            ?.map((key) => `${key}=${otherQuery[key]}`)
            .join('&')}`;
    }
    const { useRouter, Link, useLang, gtm } = useGlobal();
    const { locale, query } = useRouter();
    const { t } = useLang('shared');
    const errTipRef = useRef(null);
    const isNewVersionRegion = newVersionRegion(locale);
    const recaptchaRef = React.useRef();

    const router = useRouter();
    const [loading, setLoading] = useState(false);
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [focus, setFocus] = useState('');
    const [allValidate, setAllValidate] = useState({ email: false, password: false });
    const [isShowForget, setIsShowForget] = useState(true);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [email, setEmail] = useState('');
    const [pwd, setPwd] = useState('');
    const [kaamelInfo, setKaamelInfo] = useState<any>(null);
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];
    const mfStatus = isMembersFestival(locale);
    const { _source } = query;

    const { backgroundImage, isLoaded, isAnimating, imageUrl } = usePageBackground(locale);

    let HOME_HOST = `${WEB_HOST}/${router.locale}`;
    // 社区
    if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
        HOME_HOST = `${FORUM_HOST}/${router.locale}`;
    }
    // 家储
    if (redirectUrl.indexOf('https://homebattery') > -1 || redirectUrl.indexOf('https://enterprise') > -1) {
        HOME_HOST = `${HOMEBATTERY_REDIRECT}${router.locale}`;
    }
    const [form] = Form.useForm();
    const LOGIN_HOST = getHostApi(router.locale).NEXT_PUBLIC_LOGIN_HOST;
    let open_site: string | undefined = '';
    switch (getCountryRegion(locale)) {
        case 'cn':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_CN;
            break;
        case 'eu':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_EU;
            break;
        default:
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE;
            break;
    }

    /**
     * @description: 判断链接是内部链接还是外部，然后统一转换成完整url
     * @params url {string}
     * @return url {string}
     */
    const linkHandle = (url: string) => {
        const regex = /^(http|https|ftp):\/\//;
        if (!regex.test(url)) {
            return `${WEB_HOST}${url}`;
        }
        return url;
    };

    const getRegisterUrl = () => {
        let url = '/register';
        const { inviteCode } = query;
        // 之前的逻辑
        // const concatRedirectUrl = redirectUrl.indexOf('/support/warranty') > -1;
        // url += `?redirect=${encodeURIComponent(redirectUrl || `/${locale}/login`)}`;
        if (redirectUrl) {
            const safeFlag1 = redirectUrl.startsWith('http') || redirectUrl.startsWith('www.');
            const safeFlag2 =
                redirectUrl.indexOf('.ecoflow.com') === -1 && !redirectUrl.startsWith('https://homebattery') && !redirectUrl.startsWith('https://enterprise');
            if (safeFlag1 && safeFlag2) {
                url += `?redirect=${encodeURIComponent('/')}`;
            } else {
                url += `?redirect=${encodeURIComponent(redirectUrl)}`;
            }
        }
        // 新增裂变邀请码
        if (inviteCode) {
            if (!url.includes(inviteCode)) {
                url += `&inviteCode=${inviteCode}`;
            }
        }

        if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
            if (!url.includes(_source)) {
                url += `&_source=${_source}`;
            }
        }

        gtm.push({
            event: 'uaEvent',
            event_name: 'login_register_switch',
            button_name: lang.site_login_register,
        });

        if (!query?.redirect) {
            const signup_info = cookie.load('signup_info');
            if (!signup_info || !signup_info?.skip) {
                signupCookie({ entry_name: 'Create EcoFlow Account' });
            }
        }
        window.location.href = `/${router.locale || ''}/${url}`;
    };

    const getRegisterUrlWithoutPwd = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'login_register_switch',
                button_name: 'Register without password',
            });

            const searchParams = new URLSearchParams(window.location.search);
            const queryString = searchParams.toString();

            signupCookie({ entry_name: 'Register without password', page_url: window.location.href });
            if (router.locale) {
                window.location.href = `/${router.locale}/register/passwordless${queryString ? `?${queryString}` : ''}`;
            }
        } catch (err) {}
    };

    // 获取shopify地址
    const getShopifyUrl = (locale: string) => `https://${locale || 'us'}.ecoflow.com`;

    // googleLogin
    const googleLogin = (type: string) => {
        // 社区登录
        if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
            const loginUrl = `${LOGIN_HOST}/auth/oauth/login/google4community?returnTo=${HOME_HOST}&returnToNew=${linkHandle(redirectUrl || HOME_HOST)}`;
            return loginUrl;
        }
        return getThirdLink(type);
    };

    // 获取第三方登录链接
    const getThirdLink = (type: string) => {
        // 是否是家储
        // const IS_HOME_BATTERY = redirectUrl.indexOf('https://homebattery') > -1 || redirectUrl.indexOf('https://enterprise') > -1;
        // const rtUrl = IS_HOME_BATTERY ? `${HOME_HOST}/login?redirect=${encodeURIComponent(redirectUrl)}` : HOME_HOST;
        let url = `${LOGIN_HOST}/auth/oauth/webLogin/${type}?returnTo=${HOME_HOST}&shopifyDomain=${getShopifyUrl(
            router.locale,
        )}&returnToLogout=${`${HOME_HOST}/my-account-manage`}&returnToNew=${linkHandle(redirectUrl || HOME_HOST)}`;
        const { inviteCode } = query;
        if (inviteCode) {
            if (!url.includes(inviteCode)) {
                url += `&inviteCode2=${inviteCode}`;
            }
        }
        return url;
    };

    const goLinkLogin = (type: string) => {
        // 社区登录
        if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
            const url = `${LOGIN_HOST}/auth/oauth/login/line4community?returnTo=${HOME_HOST}&&returnToNew=${linkHandle(redirectUrl || HOME_HOST)}`;
            return url;
        }
        return getLinkAuth(type);
    };

    // JP Link Third Login
    const getLinkAuth = (type: string) => {
        let url = `${LOGIN_HOST}/auth/oauth/login/${type}?returnTo=${HOME_HOST}&&returnToNew=${linkHandle(redirectUrl || HOME_HOST)}`;
        const { inviteCode } = query;
        if (inviteCode) url += `&inviteCode2=${inviteCode}`;
        return url;
    };

    // 获取returnToNew值
    const getShopfiyReturnToNew = (url: string) => {
        // redirect > prevPath > home
        const homePath = `/${router?.locale || ''}`;
        if (typeof window === 'undefined') return homePath;

        let { redirect } = router.query;

        const origin = window.location.origin;
        if (redirect && !prevUrlBalckList.some((item: any) => redirect.includes(item))) {
            if (!redirect.startsWith('http') && !redirect.startsWith('www.')) {
                redirect = `${origin}${redirect.startsWith('/') ? redirect : `/${redirect}`}`;
                return decodeURIComponent(`${redirect}`);
            }
            if ((redirect.startsWith('http') || redirect.startsWith('www.')) && !redirect.includes('.ecoflow.com')) {
                redirect = `${origin}${homePath}`;
                return decodeURIComponent(`${redirect}`);
            }
            return decodeURIComponent(`${redirect}`);
        }

        let prevRoute = validPrePath(prevPath);
        if (prevRoute && !prevUrlBalckList.some((item: any) => prevRoute.includes(item))) {
            if (!prevRoute.startsWith('http') && !prevRoute.startsWith('www.')) {
                prevRoute = `${origin}${prevRoute.startsWith('/') ? prevRoute : `/${prevRoute}`}`;
            }
            if ((prevRoute.startsWith('http') || prevRoute.startsWith('www.')) && !prevRoute.includes('.ecolfow.com')) {
                prevRoute = `${origin}${homePath}`;
            }
            return decodeURIComponent(`${prevRoute}`);
        }
        return url || decodeURIComponent(`${origin}${homePath}`);
    };

    const syncLoginShopify = async (url: string): Promise<string> => {
        return new Promise(async (resolve, reject) => {
            let returnToNew = getShopfiyReturnToNew(url);

            // 外层对 url 判断移到这里（原有逻辑）
            if (returnToNew) {
                returnToNew = returnToNew.startsWith('http') || returnToNew.startsWith('www.') ? returnToNew : `${WEB_HOST}${returnToNew}`;
            } else {
                returnToNew = `${WEB_HOST}/${locale}`;
            }

            const params = {
                returnToNew,
                url: `https://${router?.locale}.ecoflow.com`,
            };
            const res = await authSignIn(params, router?.locale);
            if (res?.code !== '0') {
                reject(res?.message);
            } else {
                resolve(res?.data || `/${router.locale}`);
            }
        });
    };
    const {
        isOpenTwoFactor,
        getIsNeedHumanCheck,
        displayHumanMachineCheck,
        resendCode,
        setResendCode,
        sendCodeLoading,
        getIsOpenTwoFactor,
        setIsOpenTwoFactor,
        setHavedHumanMachineCheck,
        handleSendVerificationCode,
        ensureTwoFactorChecked,
    } = useLoginCode(locale, form);

    const handleBeforeFinish = async () => {
        if (displayHumanMachineCheck && recaptchaResponse) {
            onFinish({});
            return;
        }
        setLoading(true);

        try {
            const [result, data] = await getIsNeedHumanCheck();
            setLoading(false);

            if (!result) {
                // 接口错误
                setErrorTip(data);
                setIsErrorTip(true);
            }
            if (result && !data) {
                // 不需要人机校验
                onFinish({});
                return;
            }
            // 需要人机校验

            return;
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    // Login
    const onFinish = async (values: any) => {
        const recaptchaRes = displayHumanMachineCheck ? { recaptchaResponse: recaptchaResponse } : {};

        const params = {
            source: LOGIN_MAP[_source] || 'ECOFLOW_WEB',
            userType: 'ECOFLOW', //用户类型
            scene: LOGIN_MAP[_source] || 'ECOFLOW_WEB', //登陆场景
            logInSource: 1, // 处理注销用户登录
            email: values.email || email,
            password: Base64.stringify(Utf8.parse(values.password || pwd)),
            websiteTwoFactorAuthCode: form.getFieldsValue()['websiteTwoFactorAuthCode'] || '',
            ...recaptchaRes,
        };

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_login',
            button_name: lang.site_login_login,
        });

        setLoading(true);

        try {
            const res: any = await toLogin(params, '', _source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY ? FORUM_APPID_MAP[locale] : '');
            if (res.code === '0') {
                // const redirectUrl = '';
                const { redirect = '', scene } = router.query;
                // 是否是家储
                const IS_HOME_BATTERY = redirect.indexOf('https://homebattery') > -1 || redirect.indexOf('https://enterprise') > -1;
                // 用户信息存储到cookie中
                onLogin(res.data, IS_HOME_BATTERY);

                // 注销中的用户跳转到个人用户页取消注销
                if (res.data?.user?.destroyed === 'DESTROY') {
                    window.location.href = `/${router.locale || ''}/my-account-manage`;
                    return;
                }

                const decodeRedirect = decodeURIComponent(redirect);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'login',
                    page_name: '/login',
                });

                // wordpress 系统第三方
                if (redirect && scene) {
                    if (redirect.includes(HOMEBATTERY_REDIRECT)) {
                        // window.location.href = `${decodeRedirect}?user=${encodeURIComponent(res.data)}`;
                        window.location.href = decodeRedirect;
                        return;
                    }

                    // 测试环境地址http://10.10.12.33/redirect.html
                    window.location.href = `${wordpress_site}?returnTo=${decodeRedirect}&token=${res.data.token}`;
                    return;
                }

                //open开发平台
                if (window.opener) {
                    window.opener.postMessage(
                        {
                            userInfo: res.data?.user,
                            token: res.data.token,
                        },
                        open_site,
                    );
                }

                /**
                 * @todo 原积分系统已弃用，现在已经迁移到新官网内部
                 */
                // http://10.10.10.168:3007/points?type=website&website=JAPAN&token=xxx
                // 处理个人积分跳转后，登录过期，跳转回来登录，登录成功后再返回到具体url，暂时用http://10.10.10.168:3007站点
                try {
                    const res2 = await syncLoginShopify(redirect);
                    if (otherQuery && Object.keys(otherQuery).includes('tab')) {
                        window.location.href = redirectUrl;
                    } else {
                        window.location.href = String(res2);
                    }
                } catch (err) {
                    sendPostErrorMonitoring(locale, {
                        error_type_1: 'user-error',
                        error_type_2: 'login',
                        error_content_1: `syncLoginShopify ${err}`,
                    });
                    window.location.href = `/${router.locale || ''}`;
                } finally {
                    setLoading(false);
                }
            } else {
                handleLoginError(res);
            }
        } catch (e) {
            handleLoginError({ message: 'error happened' });
        }
    };

    const handleLoginError = (res: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'login_fail',
            page_name: '/login',
        });
        sendPostErrorMonitoring(locale, {
            error_type_1: 'user-error',
            error_type_2: 'login',
            error_content_1: res.code,
            error_content_2: res.message,
        });
        setLoading(false);
        setErrorTip(res.message);
        setIsErrorTip(true);
    };
    // 人机校验 start
    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) {
            setHavedHumanMachineCheck(false);
            setRecaptchaResponse('');
            return;
        }
        setHavedHumanMachineCheck(true);
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };

    // 处理多行错误提示
    useEffect(() => {
        const element: any = errTipRef.current;

        if (!element) return;

        const checkMultiline = () => {
            if (element) {
                const singleLineHeight = parseInt(getComputedStyle(element).lineHeight, 10);
                const totalHeight = element.clientHeight;
                setIsShowForget(!(totalHeight > singleLineHeight));
            }
        };

        const resizeObserver = new ResizeObserver(checkMultiline);
        resizeObserver.observe(element);

        return () => {
            if (element) resizeObserver.unobserve(element);
        };
    }, [errTipRef]);

    useEffect(() => {
        const info = getKaamelPlan();
        setKaamelInfo(info);
    }, []);

    return (
        <PageLayout className={css.loginPageLayout}>
            <div
                className={`${css.fullscreenBackground} ${isLoaded ? css.loaded : ''} ${isAnimating ? css.fadeIn : ''}`}
                style={
                    {
                        '--bg-image': backgroundImage ? `url(${backgroundImage})` : 'none',
                    } as React.CSSProperties & { '--bg-image': string }
                }
            />
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={router.asPath.substr(1)} />
            {locale === 'sa' && (
                <Head>
                    <meta name="robots" content="noindex, nofollow" key="robots" />
                    <meta name="googlebot" content="noindex, nofollow" key="googlebot" />
                </Head>
            )}
            <div className={`${css.login} login_page_a`}>
                <div className={'login-box'}>
                    {/* <div className="left">
                        <Image
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715568541033/login_banner.jpeg"
                            width={400}
                            height={679}
                            alt={lang.site_login_your_ecoflow}
                        ></Image>
                    </div> */}
                    <div className="right">
                        <h1>{lang.site_login_your_ecoflow}</h1>
                        <div className="content-wrapper">
                            <Form
                                name="normal_login"
                                className="login-form"
                                form={form}
                                autoComplete="off"
                                initialValues={{ remember: true }}
                                onValuesChange={(cValues) => form.validateFields(Object.keys(cValues))}
                            >
                                <div className="inputItem">
                                    <label className={(form.getFieldsValue()['email'] || focus === 'email') && 'active'}>{lang.site_login_email}</label>

                                    <Form.Item
                                        name="email"
                                        shouldUpdate
                                        rules={[
                                            () => ({
                                                async validator(_, value) {
                                                    const regx =
                                                        /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                                    if (!value) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ email: false },
                                                        });
                                                        setIsOpenTwoFactor(false);
                                                        return Promise.reject(new Error(lang.site_login_tip_email_empty));
                                                    }

                                                    if (value && !regx.test(value)) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ email: false },
                                                        });
                                                        setIsOpenTwoFactor(false);
                                                        return Promise.reject(new Error(lang.site_login_tip_email_format_incorrect));
                                                    }

                                                    setEmail(value);
                                                    setAllValidate({
                                                        ...allValidate,
                                                        ...{ email: true },
                                                    });
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                        validateTrigger="onBlur"
                                    >
                                        <Input
                                            className="default-input"
                                            onFocus={() => setFocus('email')}
                                            onBlur={async () => {
                                                // 邮箱去空格
                                                const { email, password } = form.getFieldsValue();
                                                form.setFieldsValue({ password, email: email?.trim() });
                                                await form.validateFields(['email']);
                                                getIsOpenTwoFactor(email);
                                                setFocus('');
                                            }}
                                            autoComplete="off"
                                            aria-label={t('logintips.email')}
                                        />
                                    </Form.Item>
                                </div>
                                {isOpenTwoFactor && (
                                    <div className="inputItem">
                                        <label
                                            className={
                                                form.getFieldsValue()['websiteTwoFactorAuthCode'] || focus === 'websiteTwoFactorAuthCode' ? 'active' : ''
                                            }
                                        >
                                            {/* {'Code'} */}
                                            {t('logintips.site_register_enter_code')}
                                        </label>
                                        <Form.Item
                                            name="websiteTwoFactorAuthCode"
                                            rules={[{ required: true, message: t('logintips.site_register_enter_code_tip') }]}
                                        >
                                            <Input
                                                className="default-input verify-code"
                                                autoComplete="off"
                                                aria-label={t('logintips.site_register_enter_code')}
                                                maxLength={6}
                                                onFocus={() => setFocus('websiteTwoFactorAuthCode')}
                                                // onFocus={(e: any) => onFocusInput(e, 'code')}
                                                // onBlur={(e: any) => onBlurInput(e, 'code')}
                                                suffix={
                                                    <Button
                                                        type="link"
                                                        className={`send-code-btn ${!allValidate.email || resendCode > 0 ? 'disabled' : ''}`}
                                                        loading={sendCodeLoading}
                                                        disabled={resendCode > 0}
                                                        onClick={() => handleSendVerificationCode(recaptchaResponse)}
                                                    >
                                                        {resendCode > 0 ? (
                                                            <CountDown
                                                                sec={resendCode}
                                                                secUnit="s"
                                                                isNeedSaveCookie={false}
                                                                onFinish={() => setResendCode(0)}
                                                            />
                                                        ) : (
                                                            t('logintips.site_get_code')
                                                        )}
                                                    </Button>
                                                }
                                            />
                                        </Form.Item>
                                    </div>
                                )}

                                <input type="password" style={{ display: 'none' }} />
                                <div className="inputItem password-item">
                                    <label className={(form.getFieldsValue()['password'] || focus === 'password') && 'active'}>
                                        {lang.site_login_password}
                                    </label>
                                    <Form.Item
                                        name="password"
                                        shouldUpdate
                                        rules={[
                                            () => ({
                                                validator(_, value) {
                                                    setIsErrorTip(false);
                                                    if (!value) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ password: false },
                                                        });
                                                        return Promise.reject(new Error(lang.site_login_tip_password_empty));
                                                    }
                                                    setPwd(value);
                                                    setAllValidate({
                                                        ...allValidate,
                                                        ...{ password: true },
                                                    });
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                        validateTrigger="onChange"
                                    >
                                        <Input.Password
                                            type="password"
                                            className="default-input"
                                            autoComplete="new-password"
                                            onFocus={() => setFocus('password')}
                                            onBlur={() => setFocus('')}
                                            iconRender={(visible: boolean) => <div>{visible ? <EFAkIn className={'iconfont'} /> : <EFAkout />}</div>}
                                            aria-label={t('logintips.pwd')}
                                        />
                                    </Form.Item>
                                    {isErrorTip && (
                                        <div ref={errTipRef} className="error-tip">
                                            {errorTip}
                                        </div>
                                    )}
                                </div>
                                <div className={`${isErrorTip ? 'inline-item validate-error' : 'inline-item'} ${!isShowForget ? 'hide-text' : ''}`}>
                                    <Link
                                        href="/forget"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'forgot_password',
                                            button_name: lang.site_login_forgot_password,
                                        }}
                                        selfWin
                                        ariaLabel={lang.site_login_forgot_password}
                                    >
                                        <span className="login-form-inline-forgot">{lang.site_login_forgot_password}</span>
                                    </Link>
                                </div>

                                {true && (
                                    <Form.Item
                                        name="recaptchaResponse"
                                        rules={[
                                            {
                                                validator() {
                                                    if (recaptchaResponse) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                },
                                            },
                                        ]}
                                        style={{ marginTop: '12px', marginBottom: '32px', display: displayHumanMachineCheck ? 'block' : 'none' }}
                                    >
                                        <div className="g-recaptcha">
                                            {/* @ts-ignore */}
                                            <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                        </div>
                                    </Form.Item>
                                )}
                                <Form.Item className="form-item1">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="black-btn large login-form-button login-btn"
                                        loading={loading}
                                        disabled={!(allValidate.email && allValidate.password)}
                                        aria-label={lang.site_login_login}
                                        onClick={async () => {
                                            // 确保检查过双因子（处理自动填充未触发 blur 的情况）
                                            const hasTwoFactor = await ensureTwoFactorChecked();
                                            if (!hasTwoFactor) {
                                                // 需要双因子验证，等待用户输入验证码
                                                await getIsOpenTwoFactor(form.getFieldsValue()['email']);
                                                return;
                                            }
                                            if (isOpenTwoFactor) {
                                                await form.validateFields(['websiteTwoFactorAuthCode']);
                                            }
                                            if (isNewVersionRegion) {
                                                handleBeforeFinish();
                                            } else {
                                                await onFinish({});
                                            }
                                        }}
                                    >
                                        {lang.site_login_login}
                                    </Button>
                                </Form.Item>
                            </Form>
                            <EcoCreditDescription
                                title={lang.ecocredit_title}
                                word1={lang.ecocredit_word1}
                                word2={lang.ecocredit_word2}
                                word3={lang.ecocredit_word3}
                                alternativeWord1={lang.ecocredit_word1_1}
                            />
                            <div className="navigate-content">
                                <button
                                    className="login-form-register-button"
                                    onClick={() => {
                                        getRegisterUrl();
                                    }}
                                >
                                    {lang.site_login_register}
                                </button>
                                <button className="login-form-register-button" onClick={getRegisterUrlWithoutPwd}>
                                    {lang.site_login_register1}
                                </button>
                            </div>

                            <div className="divider-line">{`- ${lang.site_login_or} -`}</div>
                            {/* <div className="items-oterplatform-login">
                                <div className={`google-link ${locale !== 'jp' ? 'full_width' : ''}`}>
                                    <Link
                                        ariaLabel={lang.site_login_google}
                                        href={`${googleLogin('google4website')}`}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'click_login',
                                            button_name: 'Google',
                                        }}
                                        selfWin
                                    >
                                        <Button className="oterplatform-button" aria-label={lang.site_login_google}>
                                            <span
                                                style={{
                                                    display: 'inline-flex',
                                                    verticalAlign: 'middle',
                                                    marginRight: '12px',
                                                }}
                                            >
                                                <Image src="/icons/ga.svg" width="31" height="31" alt={lang.site_login_google}></Image>
                                            </span>
                                            {lang.site_login_google}
                                        </Button>
                                    </Link>
                                </div>
                                {locale === 'jp' && (
                                    <div className="line-link">
                                        <Link
                                            ariaLabel={lang.site_login_google}
                                            href={`${goLinkLogin('line4register')}`}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'click_login',
                                                button_name: 'LINE',
                                            }}
                                            selfWin
                                        >
                                            <Button className="oterplatform-button" aria-label={'Line Button'}>
                                                <span
                                                    style={{
                                                        display: 'inline-flex',
                                                        verticalAlign: 'middle',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    <Image src="/icons/line.svg" width="28" height="28" alt={'Line'}></Image>
                                                </span>
                                                LINE
                                            </Button>
                                        </Link>
                                    </div>
                                )}
                            </div> */}
                            {/* {renderLinks()} */}
                            <SocialLoginLinks redirectUrl={redirectUrl} showLineLogin={locale === 'jp'} />
                            <div className="items-protocols">
                                {t.rich('logintips.protocol', {
                                    link1: (children: any) => (
                                        <Link
                                            href={
                                                locale === 'cis'
                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/PrivacyPolicy.html'
                                                    : locale === 'uk' && kaamelInfo?.privacyUrl
                                                    ? kaamelInfo?.privacyUrl
                                                    : `https://account.ecoflow.com/agreement/${i18nMap[locale] || i18nMap.us}/PrivacyPolicy.html`
                                            }
                                            newWin
                                            ariaLabel={t('privacy')}
                                        >
                                            {children}
                                        </Link>
                                    ),
                                    link2: (children: any) => (
                                        <Link
                                            href={
                                                locale === 'cis'
                                                    ? 'https://account.ecoflow.com/agreement/ru-cis/TermsOfUse.html'
                                                    : `https://account.ecoflow.com/agreement/${i18nMap[locale] || i18nMap.us}/TermsOfUse.html`
                                            }
                                            newWin
                                            ariaLabel={t('TOU')}
                                        >
                                            {children}
                                        </Link>
                                    ),
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const { redirect, ...otherQuery } = context.query;
    const { locale } = context;
    if (['cn', 'nl'].includes(locale)) {
        return redirectTo404();
    }
    let prevPath = context.req.headers.referer;

    if (prevPath) {
        prevPath = prevPath.indexOf('register') > 0 ? '' : prevPath;
    }
    return {
        props: {
            redirect: redirect || '',
            prevPath: prevPath || '',
            otherQuery,
        },
    };
}

// 校验上一页来源是否同源, 如果是返回目标route，否则返回空字符串
function validPrePath(path: string) {
    if (typeof window !== 'undefined') {
        const origin = (window as any).location.origin;
        return (path.includes(origin) && path) || '';
    }
    return '';
}
